import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import useAgency from 'features/Agency/useAgency';
import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

ChargePricingListFilterView.propTypes = {
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
  initialSelectedInvestor: PropTypes.object,
  initialSelectedStation: PropTypes.object,
  initialSelectedPoint: PropTypes.object,
  onSelectedInvestorChange: PropTypes.func,
  onSelectedStationChange: PropTypes.func,
  onSelectedPointChange: PropTypes.func,
};

function ChargePricingListFilterView({
  onCancel,
  onApply,
  closeDropdown,
  initialSelectedInvestor,
  initialSelectedStation,
  initialSelectedPoint,
  onSelectedInvestorChange,
  onSelectedStationChange,
  onSelectedPointChange,
}) {
  // MARK: ---- PROPERTIES ----
  const { operatorList, operatorOptions } = useAgency();
  const [filterQ, setFilterQ] = useState('');
  const [filterInvestorId, setFilterInvestorId] = useState('');
  const [filterStationId, setFilterStationId] = useState('');
  const [filterPointId, setFilterPointId] = useState('');
  const [filterOperatorId, setFilterOperatorId] = useState('');
  const [selectedInvestor, setSelectedInvestor] = useState(null);
  const [selectedStation, setSelectedStation] = useState(null);
  const [selectedPoint, setSelectedPoint] = useState(null);
  useEffect(() => {
    setFilterQ(ChargeHelper.Filter.chargePricingList.q);
    setFilterInvestorId(ChargeHelper.Filter.chargePricingList.agencyId);
    setFilterStationId(ChargeHelper.Filter.chargePricingList.stationId);
    setFilterPointId(ChargeHelper.Filter.chargePricingList.pointId);
    setFilterOperatorId(ChargeHelper.Filter.chargePricingList.operatorId);
  }, [ChargeHelper.Filter.chargePricingList]);
  useEffect(() => {
    setSelectedInvestor(initialSelectedInvestor);
    setSelectedStation(initialSelectedStation);
    setSelectedPoint(initialSelectedPoint);
  }, [initialSelectedInvestor, initialSelectedStation, initialSelectedPoint]);
  const dropdownInvestorEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="filter_investorId"
        name="filter_investorId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
            type="button"
          >
            {selectedInvestor?.name ?? 'Chọn nhà đầu tư'}
          </button>
        }
        selectedValue={selectedInvestor}
        subTitleType="email"
        dropdownMenuItems={[{ name: 'Nhà đầu tư NQ', role: 'INVESTOR' }]}
        getSubItems={async (item) => {
          return AgencyHelper.API.requestGetAgencyList({
            role: AgencyConstants.AgencyRole.INVESTOR,
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.agencies?.map((row) => ({
                id: row?.agencyId,
                name: row?.name,
                item: row,
                email: row?.email,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedInvestor(value);
          setSelectedStation(null);
          setSelectedPoint(null);
          setFilterInvestorId(value?.id);
          setFilterStationId('');
          setFilterPointId('');
          setFilterOperatorId('');
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'Nhà đầu tư NQ',
          role: 'INVESTOR',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedInvestor(null);
              setSelectedStation(null);
              setSelectedPoint(null);
              setFilterInvestorId('');
              setFilterStationId('');
              setFilterPointId('');
            })}
          </div>
        }
      />
    );
  }, [selectedInvestor]);
  const dropdownChargeStationEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="filter_stationId"
        name="filter_stationId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
            type="button"
          >
            {selectedStation?.name ?? 'Chọn trạm sạc'}
          </button>
        }
        selectedValue={selectedStation}
        dropdownMenuItems={[{ name: 'Trạm sạc', role: 'CHARGE_STATION' }]}
        getSubItems={async (item) => {
          return ChargeHelper.API.requestGetChargeStationList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.chargeStations?.map((row) => ({
                id: row?.stationId,
                name: row?.stationCode ? `${row?.stationCode} - ${row?.name ?? ''}` : row?.name,
                item: row,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedStation(value);
          setSelectedInvestor(null);
          setSelectedPoint(null);
          setFilterStationId(value?.id);
          setFilterInvestorId('');
          setFilterPointId('');
          setFilterOperatorId('');
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'Trạm sạc',
          role: 'CHARGE_STATION',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedStation(null);
              setSelectedInvestor(null);
              setSelectedPoint(null);
              setFilterStationId('');
              setFilterInvestorId('');
              setFilterPointId('');
            })}
          </div>
        }
      />
    );
  }, [selectedStation]);
  const dropdownChargePointEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="filter_pointId"
        name="filter_pointId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
            type="button"
          >
            {selectedPoint?.name ?? 'Chọn trụ sạc'}
          </button>
        }
        selectedValue={selectedPoint}
        dropdownMenuItems={[{ name: 'Trụ sạc', role: 'CHARGE_POINT' }]}
        getSubItems={async (item) => {
          return ChargeHelper.API.requestGetChargePointList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.chargePoints?.map((row) => ({
                id: row?.pointId,
                name: row?.pointCode,
                item: row,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedPoint(value);
          setSelectedStation(null);
          setSelectedInvestor(null);
          setFilterPointId(value?.id);
          setFilterStationId('');
          setFilterInvestorId('');
          setFilterOperatorId('');
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'Trụ sạc',
          role: 'CHARGE_POINT',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedPoint(null);
              setSelectedStation(null);
              setSelectedInvestor(null);
              setFilterPointId('');
              setFilterStationId('');
              setFilterInvestorId('');
            })}
          </div>
        }
      />
    );
  }, [selectedPoint]);

  // MARK: ---- METHODS ----
  const handleApplyFilter = () => {
    ChargeHelper.Filter.chargePricingList = {
      q: filterQ,
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      operatorId: filterOperatorId,
      agencyId: filterInvestorId,
      stationId: filterStationId,
      pointId: filterPointId,
    };
    if (onSelectedInvestorChange) onSelectedInvestorChange(selectedInvestor);
    if (onSelectedStationChange) onSelectedStationChange(selectedStation);
    if (onSelectedPointChange) onSelectedPointChange(selectedPoint);
    if (onApply) onApply();
    if (closeDropdown) closeDropdown();
  };
  const handleClearFilter = () => {
    ChargeHelper.Filter.chargePricingList = {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      operatorId: '',
      agencyId: '',
      stationId: '',
      pointId: '',
    };
    setSelectedInvestor(null);
    setSelectedStation(null);
    setSelectedPoint(null);
    if (onSelectedInvestorChange) onSelectedInvestorChange(null);
    if (onSelectedStationChange) onSelectedStationChange(null);
    if (onSelectedPointChange) onSelectedPointChange(null);
    if (onCancel) onCancel();
    if (closeDropdown) closeDropdown();
  };

  return (
    <div className="py-4">
      <div className="row m-0 px-2">
        {/* tim kiem */}
        <div className="col-12 mb-4 px-2">
          <KTFormSearch
            name="search_filter"
            placeholder="Nhập để tìm kiếm..."
            value={filterQ}
            onSubmit={(text) => {
              setFilterQ(text);
            }}
          />
        </div>
        {/* loc theo nha dieu hanh */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Nhà điều hành')}
          <KTBSDropdown
            name="filter_operatorId"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(operatorList, (item) => item?.operatorId === filterOperatorId)?.name ??
                  'Tất cả'}
              </button>
            }
            selectedValue={filterOperatorId}
            dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...operatorOptions]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setSelectedPoint(null);
              setSelectedStation(null);
              setSelectedInvestor(null);
              setFilterOperatorId(value);
              setFilterInvestorId('');
              setFilterStationId('');
              setFilterPointId('');
            }}
            isDropdownForm={true}
          />
        </div>
        {/* loc theo nha dau tu */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Nhà đầu tư NQ')}
          {dropdownInvestorEl}
        </div>
        {/* loc theo tram sac */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Trạm sạc')}
          {dropdownChargeStationEl}
        </div>
        {/* loc theo tru sac */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Trụ sạc')}
          {dropdownChargePointEl}
        </div>
      </div>
      {/* actions */}
      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
        {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
      </div>
    </div>
  );
}

export default ChargePricingListFilterView;
